
<div class=" ">
    <div class="flex justify-between items-center">
        <!-- <span class="font-bold text-gray flex gap-3">
             <fa-icon [icon]="faThermometer"></fa-icon> Warehouse Sensors
        </span> -->

        <!-- <div>
            <button *ngxPermissionsOnly="addPermission" (click)="onAdd()" mat-raised-button color="primary" style="background-color: #005590;">
                <mat-icon>add</mat-icon>
                Add Sensor
            </button>
        </div> -->
    </div>
</div>

<div class="">
    <app-paginated-data-table
            [resetTable]="refresh"
            [tableConfigurations]="tableConfiguration"
            [permissions]="permissions"
            (customAction)="onCustomAction($event)"
            [query]="query"
            [pageSize]="5"
            [upsertAction]="upsertAction"
            [deleteAction]="deleteAction"
            [mapFunction]="mapFunction"
            [additionalVariables]="filters"
            [actionButtons]="actionButtons">
    </app-paginated-data-table>
</div>
